// UserMFAView.jsx
import { Box, Typography } from "@mui/material";
import { isObject } from "formik";
import { useEffect, useState } from "react";
import useColors from "../../../../../../api/hooks/useColors";
import {
  getPrettyDateTime,
  useLocalTime,
} from "../../../../../../utils/timestamp";
import IntegrationImage from "../../../../integrations/components/IntegrationImage";
import { getUserMFARows } from "./checkRowsUserData";

const UserMFAView = ({ entityData }) => {
  const [rows, setRows] = useState([]);
  const colors = useColors();
  const showLocalTime = useLocalTime();
  useEffect(() => {
    setRows(getUserMFARows(entityData));
  }, [entityData]);

  const mfaEnforcedExist = rows.some((row) => row.enforced);
  const mfaEnabled = rows.some((row) => row.enabled);
  const mfaFactorTypeExist = rows.some((row) => row.factor_type);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 1,
      }}
    >
      {mfaEnforcedExist && (
        <>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: 1,
            }}
          >
            <Typography variant={"subtitle2"}>MFA Enforced</Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 1,
              marginLeft: "24px",
            }}
          >
            {rows.map((row, index) => {
              return (
                row.enforced && (
                  <Box
                    display={"flex"}
                    flexDirection={"row"}
                    alignItems={"center"}
                    gap={1}
                    key={index}
                  >
                    <IntegrationImage
                      name={row.source}
                      width={"16px"}
                      newLogo={true}
                    />
                    <Typography variant="caption">{row.enforced}</Typography>
                  </Box>
                )
              );
            })}
          </Box>
        </>
      )}
      {mfaEnabled && (
        <>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: 1,
            }}
          >
            <Typography variant={"subtitle2"}>MFA Enabled</Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 1,
              marginLeft: "24px",
            }}
          >
            {rows.map((row, index) => {
              return (
                row.enabled && (
                  <Box
                    display={"flex"}
                    flexDirection={"row"}
                    alignItems={"center"}
                    gap={1}
                    key={index}
                  >
                    <IntegrationImage
                      name={row.source}
                      width={"16px"}
                      newLogo={true}
                    />
                    <Typography variant="caption">{row.enabled}</Typography>
                  </Box>
                )
              );
            })}
          </Box>
        </>
      )}
      {mfaFactorTypeExist && (
        <>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: 1,
            }}
          >
            <Typography variant={"subtitle2"}>Factor Type</Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 1,
              marginLeft: "24px",
            }}
          >
            {rows.map((row, index) => {
              let value = "N/A"; // fallback

              if (row.last_updated) {
                if (
                  isObject(row.last_updated) &&
                  row.last_updated.hasOwnProperty("timestamp_utc")
                ) {
                  value = getPrettyDateTime(
                    row.last_updated.timestamp_utc,
                    showLocalTime
                  );
                } else {
                  value = row.last_updated;
                }
              }

              return (
                row.factor_type && (
                  <Box
                    key={index}
                    display={"flex"}
                    gap={1}
                    alignItems={"flex-start"}
                  >
                    <IntegrationImage
                      name={row.source}
                      width={"16px"}
                      newLogo={true}
                    />
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 0.5,
                      }}
                    >
                      <Typography variant="caption">
                        {row.factor_type}
                      </Typography>
                      {
                        <Typography
                          variant="caption"
                          sx={{
                            color: colors.text_secondary,
                          }}
                        >
                          Last Update: {" " + value}
                        </Typography>
                      }
                    </Box>
                  </Box>
                )
              );
            })}
          </Box>
        </>
      )}
    </Box>
  );
};

export default UserMFAView;
